import { render } from "./TheGuide.vue?vue&type=template&id=05b83586&scoped=true&ts=true"
import script from "./TheGuide.vue?vue&type=script&lang=ts"
export * from "./TheGuide.vue?vue&type=script&lang=ts"

import "./TheGuide.vue?vue&type=style&index=0&id=05b83586&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b83586"]])

export default __exports__